import React, { useEffect, useState } from "react";
import Header from "../../../../Layout/Header/Header";
import CustomRewardPoints from "../../../../CustomComponents/CustomRewardPoints";
import Icons from "../../../../../../Config/Images";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../../../Layout/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  getMilestonesAPI,
  getRewardPointsAPI,
} from "../../../../../../Store/Action/rewardPointsAction";

const ProductsRewardPoint = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [targets, setTargets] = useState([]);
  const [overallProgress, setOverallProgress] = useState(0);
  // useEffect(() => {
  //   dispatch(
  //     getRewardPointsAPI({}, (result) => {
  //       if (result?.status) {
  //         // ✅ set individual category targets
  //         if (Array.isArray(result.data)) {
  //           const formattedTargets = result.data.map((item) => {
  //             const subCat = item.product_sub_category?.[0] || {};
  //             return {
  //               id: subCat.product_category_id,
  //               name: subCat.product_category_name,
  //               progress: item.milestone_percentage || 0,
  //               weight: item.milestone_category_net_weight,
  //             };
  //           });
  //           setTargets(formattedTargets);
  //         }

  //         // ✅ set overall progress
  //         if (result?.summary?.overall_percentage !== undefined) {
  //           setOverallProgress((result.summary.overall_percentage || 0) );
  //         }
  //       }
  //     })
  //   );
  // }, [dispatch]);
  const rewardPointUnitId = useSelector(
    (state) => state.rewardPoint.rewardPointUnitId
  );

  useEffect(() => {
    const params = { reward_point_unit_id: rewardPointUnitId };

    dispatch(
      getMilestonesAPI(params, (result) => {
        if (result?.status && Array.isArray(result.data)) {
          const formattedTargets = result.data.map((item) => {
            // CASE 1 → Refer & Earn
            if (item.milestone_name === "Refer & Earn") {
              return {
                id: item.milestone_id,
                name: "Refer & Earn",
                progress: item.milestone_percentage || 0,
                weight: item.milestone_condition,
                unit: "",
                mileStoneId: item.milestone_id,
                mileStoneFlag: item.milestone_flag,
                subCategories: item.sub_categories,
              };
            }

            // CASE 2 → Per Pcs Product
            if (item.milestone_name === "Per Pcs Product") {
              return {
                id: item.milestone_id,
                name: item.milestone_name,
                progress: item.milestone_percentage || 0,
                weight: item.milestone_condition || 0,
                unit: "",
                mileStoneId: item.milestone_id,
                mileStoneFlag: item.milestone_flag,
                subCategories: item.sub_categories,
              };
            }

            // DEFAULT CASE → treat as normal milestone (gm unit)
            return {
              id: item.milestone_id,
              name: item.milestone_name,
              progress: item.milestone_percentage || 0,
              weight: item.milestone_condition || 0,
              unit: item.milestone_unit || "gm",
              mileStoneId: item.milestone_id,
              mileStoneFlag: item.milestone_flag,
              subCategories: item.sub_categories,
            };
          });

          setTargets(formattedTargets);

          // Set overall progress
          if (result?.summary?.overall_percentage !== undefined) {
            setOverallProgress(result.summary.overall_percentage || 0);
          }
        }
      })
    );
  }, [dispatch]);

  const headerTextName = location.state?.header_name || "Reward Points";
  // const targets = [
  //   { name: "Ring 500gm", progress: 10 },
  //   { name: "Bracelete 1Kg", progress: 80 },
  //   { name: "Bangles 750gm", progress: 30 },
  //   { name: "Nosepin 750gm", progress: 20 },
  //   { name: "Ruby 250gm", progress: 70 },
  //   { name: "Ring 500gm", progress: 10 },
  //   { name: "Bracelete 1Kg", progress: 80 },
  //   { name: "Bangles 750gm", progress: 30 },
  //   { name: "Nosepin 750gm", progress: 20 },
  //   { name: "Ruby 250gm", progress: 70 },
  // ];
  const progress = 50; // Set the progress percentage here
  // Calculate the left position for the percentage circle
  const leftPosition =
    progress === 0 ? `calc(${progress}% - 25px)` : `${progress}%`;

  return (
    <>
      <Header />
      <CustomRewardPoints
        progress={overallProgress}
        headerText={headerTextName}
        imageSrc={Icons.free_world_tour_img}
        targets={targets}
        rewardForIndividualProductFlag={true}
      />
      <Footer />
    </>
  );
};

export default ProductsRewardPoint;
